import { Splide } from "@splidejs/splide";

const mq = window.matchMedia("(max-width: 768px)");

document.addEventListener("alpine:init", () => {
    Alpine.data("articleTeasers", () => ({
        splide: null,
        splideOptions: {
            drag: true,
            arrows: false,
            isNavigation: false,
            pagination: false,
            perPage: 1,
        },

        init() {
            if (mq.matches) {
                this.splide = new Splide(this.$refs.slider, this.splideOptions);
                this.splide.mount();
            }
        },
    }));
});
